import { useState } from "react";
import { Day, TimeRange } from "./types";

interface PendingDelete {
  day: Day;
  eventIndex: number;
  event: TimeRange;
}

interface DeleteEventConfirmation {
  // Solicita eliminar un evento: pide confirmación o lo borra directamente
  // según `confirmDeleteEvent`.
  requestDelete: (day: Day, eventIndex: number, event: TimeRange) => void;
  // Evento pendiente de confirmar su borrado (null si no hay diálogo abierto).
  pending: PendingDelete | null;
  onConfirm: () => void;
  onCancel: () => void;
}

// Lógica de borrado con confirmación opcional, compartida entre las vistas de
// escritorio y móvil del WeeklyCalendar.
export function useDeleteEventConfirmation(
  deleteEvent: (day: Day, eventIndex: number) => void,
  confirmDeleteEvent: boolean
): DeleteEventConfirmation {
  const [pending, setPending] = useState<PendingDelete | null>(null);

  const requestDelete = (day: Day, eventIndex: number, event: TimeRange) => {
    if (confirmDeleteEvent) {
      setPending({ day, eventIndex, event });
    } else {
      deleteEvent(day, eventIndex);
    }
  };

  const onConfirm = () => {
    if (pending) {
      deleteEvent(pending.day, pending.eventIndex);
    }
    setPending(null);
  };

  const onCancel = () => setPending(null);

  return { requestDelete, pending, onConfirm, onCancel };
}
